import React, { useEffect, useState } from "react";
import { Container, Typography, Box, Button } from "@mui/material";
import CountUp from "react-countup";
import axios from "axios";

const HappyUsersCounter = () => {
  const [totalUsers, setTotalUsers] = useState(0);

  useEffect(() => {
    const fetchTotalUsers = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/public/total-users`
        );
        setTotalUsers(response.data.totalUsers || 0);
      } catch (error) {
        console.error("Error fetching total users:", error);
        setTotalUsers(0);
      }
    };

    fetchTotalUsers();
  }, []);

  return (
    <Container sx={{ textAlign: "center", py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Join our growing community of
      </Typography>
      <Box
        sx={{
          display: "inline-block",
          fontSize: "3rem",
          fontWeight: "bold",
          color: "primary.main",
        }}
      >
        <CountUp end={totalUsers} duration={5} separator="," />
      </Box>
      <Typography variant="h5" sx={{ mt: 1 }}>
        🎉 Happy tool-lovers! 🛠️
      </Typography>

      {/* Enhanced CTA Button */}
      <Button
        variant="contained"
        size="large"
        href="/welcome/signup"
        sx={{
          mt: 4,
          px: 5,
          py: 1.5,
          borderRadius: 4,
          textTransform: "none",
          fontWeight: "bold",
          fontSize: "1rem",
          bgcolor: "primary.main",
          color: "primary.contrastText",
          position: "relative",
          overflow: "hidden",
          boxShadow: "0 4px 20px rgba(33, 203, 243, 0.3)",
          transition: "all 0.3s ease-in-out",
          border: "2px solid transparent", // no border initially
          "&:hover": {
            bgcolor: "primary.contrastText", // background white (or contrast)
            color: "primary.main", // text primary color
            borderColor: "primary.main", // border same as text color
          },
        }}
      >
        🚀 Join Us Today!
      </Button>
    </Container>
  );
};

export default HappyUsersCounter;
